import { Flex, LoadingOverlay, Title } from '@mantine/core';
import { PropsWithChildren } from 'react';

interface Props {
	loading: boolean;
	error?: boolean;
	isEmpty?: boolean;
	isEmptyMessage?: string;
	isErrorMessage?: string;
}

export const ContentWithLoad = (props: PropsWithChildren<Props>) => {
	const {
		loading,
		error = false,
		isEmpty = false,
		isEmptyMessage = '',
		isErrorMessage = '',
	} = props;

	const formattedMessage = (message: string) => {
		return (
			<Flex direction="column" gap={10} align="center" justify="center" flex={1}>
				<Title order={2} ta="center">
					{message}
				</Title>
			</Flex>
		);
	};

	if (loading) {
		return <LoadingOverlay visible zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />;
	}

	if (error) {
		return formattedMessage(isErrorMessage);
	}

	if (isEmpty) {
		return formattedMessage(isEmptyMessage);
	}

	return props.children;
};
